<template id="gradientTemplate">
    <div class="gradient__container">
        <div
            ref="gradient"
            class="parallax-gradient"
        />
    </div>
</template>

<script>

export default {
    name: 'ParallaxGradient',
    data() {
        return {
            pause: undefined,
            threshold: [],
            maxThreshold: 0.99,
        };
    },
    mounted() {
        // console.log(this.threshold);

        new IntersectionObserver(
            this.gradientIntersect,
            { threshold: this.threshold },
        ).observe(this.$refs.gradient);
    },
    created() {
        // init value for treshold array
        this.handleDecimal(0.00);
    },
    methods: {
        gradientIntersect(entries) {
            /* eslint-disable */
            /* TOO-FIX */
            const entry = entries.filter(({ target }) => {
                return target === this.$refs.gradient;
            });

            const shiftNum = `${(Math.floor(entry[0].intersectionRatio * 100))}%`;
            this.$refs.gradient.style.transform = `translateX(${shiftNum})`;
        },
        handleDecimal(number) {
            const { maxThreshold } = this;
            // recursive function to fill threshold array
            let newNumber = number;
            // console.log(newNumber.toFixed(2));
            this.threshold.push(newNumber);

            const results = newNumber < maxThreshold
                ? this.handleDecimal(newNumber += 0.01)
                : maxThreshold
            ;

            return results;
        },
    },
};
</script>

<style lang="scss">
.gradient__container {
    width: 100%;
    height: 500px;
    margin: 0 auto;
}

.parallax-gradient {
    @include glow-turquoise-gradient(0.33);
    width: 50%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ParallaxGradient.vue